<template>
    <div class="content" v-loading="loading">
        <img v-show="type==='img'" :src="src" alt="" ref="img">
        <div v-show="type==='xlsx'" ref="excel" v-html="html"></div>
        <div style="white-space: pre-wrap;" class="txt" v-show="type==='txt'">{{html}}</div>
        <div v-show="type==='docx'" ref="docx" v-html="html"></div>
        <div class="pdf" v-show="type==='pdf'">
            <pdf :src="src" @progress="progress"  :page="currentPage" @num-pages="pageCount=$event" @page-loaded="currentPage=$event" @loaded="loadPdfHandler"></pdf>
            <el-pagination
                :current-page="currentPage"
                @current-change="changePdfPage"
                :page-size="1"
                layout="total, prev, pager, next"
                :total="pageCount"
                >
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import XLSX from 'xlsx'
    import Pdf from 'vue-pdf'
    import services from "./preview.services";

    export default {

        components: {Pdf},

        props: ["file"],

        data() {
            return {
                fileList: [],
                flag: false,
                src: "",
                type: "",
                html: '',
                currentPage: 0, // pdf文件页码
                pageCount: 0, // pdf文件总页数
                loading: true
            };
        },

        mounted() {
            this.handleEdit(this.file)
        },

        methods: {
            progress(minnum){
                if (minnum === 1) {
                    this.loading = false;
                }
            },

            // 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
            changePdfPage (val) {
                this.currentPage = val;
            },

            // pdf加载时
            loadPdfHandler (e) {
                this.currentPage = 1 // 加载的时候先加载第一页
            },

            handleEdit(row) {
                this.flag = true;
                services.preview({download_url: row.url})
                    .then(res => {
                            this.type = res.type;
                            this.$modal.title = res.filename;
                            const {type} = this;
                            switch (type) {
                                case "img":
                                    this.src = res.data;
                                    this.loading = false;
                                    return true;
                                case "pdf":
                                    this.src = res.data;
                                    return true;
                                case "xlsx":
                                    const wb = XLSX.read(res.data, {type: 'base64'});
                                    const worksheet = wb.Sheets[wb.SheetNames[0]];
                                    this.html = XLSX.utils.sheet_to_html(worksheet);
                                    this.loading = false;
                                    return true;
                                case "docx":
                                    this.html = res.data + "<style>table{border-collapse: collapse;}</style>";
                                    document.querySelector('body').style = "width:100%;fontSize:0";
                                    this.loading = false;
                                    return true;
                                default:
                                    this.html = res.data;
                                    this.loading = false;
                                    return true;
                            }
                    })
                    .catch(err => {
                        this.loading = false;
                        let message = err ? err.message ? err.message : "不支持的文件格式" : "不支持的文件格式";
                        this.$message.error(message);
                    })
            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    img {
        max-width: 100%;
        max-height: 100%;
        display: block;
    }
    .content {
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        .txt {
            width: 100%;
        }
        &>div {
            width: 100%;
        }
    }
</style>
